import { useAppSelector } from '../../../store';

export const useGetTaskExecutor = (executorId: number) => {
    const { employees } = useAppSelector((state) => state.tasksInformationReducer);
    const taskExecutor = employees.filter((item) => item.id === executorId)[0];

    if (!executorId) return { executorName: '', executorAvatar: '' };

    return { executorName: taskExecutor?.name, executorAvatar: taskExecutor?.avatar_url };
};
